module.exports = __webpack_public_path__ + "static/pancit-w-pandesal-2-f185cd8839d51e07cf44052b53d31fa3.jpg";